import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import Cookies from 'js-cookie';
import fallbackText from '../store-helpers/fallback_component_text.json';

const LANG_CODE_DEFAULT = 'en';
const LANG_DEFAULT = 'English';

export const useTranslationStore = defineStore('translation', () => {
  const languages = ref([]);
  const language = ref(LANG_DEFAULT);
  const locale = ref(LANG_CODE_DEFAULT);
  const componentTranslations = ref({ ...fallbackText });

  const getLanguages = computed(() => languages.value);
  const getLanguage = computed(() => locale.value);
  const getLocale = computed(() => locale.value);
  const getLanguageText = computed(() => language.value);
  const getGlobalTranslations = computed(() => componentTranslations.value.globals);
  const getHeaderTitles = computed(() => componentTranslations.value.header);

  function getComponentTranslation(componentName) {
    if (!componentName) {
      throw new Error('You must provide a valid component name');
    }
    const nameWithoutSpaces = componentName.replace(/\s+/g, '');
    return componentTranslations.value[nameWithoutSpaces];
  }

  function setLanguages(payload) {
    languages.value = payload;
  }

  function setLanguage(payload) {
    locale.value = payload;
  }

  function setLanguageText(payload) {
    language.value = payload;
  }

  function setComponentTranslations(payload) {
    componentTranslations.value = {
      ...componentTranslations.value,
      ...payload,
    };
  }

  function setHeaderTitles(payload) {
    componentTranslations.value.header = payload;
  }

  async function updateLangCode(shouldReload) {
    const lang = Cookies.get('language') || LANG_DEFAULT;
    const langCode = Cookies.get('langCode') || LANG_CODE_DEFAULT;
    setLanguage(langCode);
    setLanguageText(lang);

    if (shouldReload && typeof window !== 'undefined') {
      location.reload();
    }
  }

  async function setLangCookies({ language: lang, code, shouldReload }) {
    Cookies.set('language', lang || LANG_DEFAULT);
    Cookies.set('langCode', code || LANG_CODE_DEFAULT);
    await updateLangCode(shouldReload);
  }

  return {
    languages,
    language,
    locale,
    componentTranslations,
    getLanguages,
    getLanguage,
    getLocale,
    getLanguageText,
    getGlobalTranslations,
    getHeaderTitles,
    getComponentTranslation,
    setLanguages,
    setLanguage,
    setLanguageText,
    setComponentTranslations,
    setHeaderTitles,
    updateLangCode,
    setLangCookies,
  };
});
